import type { EventProperties } from '../types/EventProperties';

export abstract class Analytics {
  private recordingSampleRate = 0.1; // 10% of sessions

  abstract identify(userId: string): void;
  abstract reset(): void;

  abstract captureEvent(eventName: string, properties: EventProperties): void;
  abstract setUserProperties(properties: EventProperties): void;
  abstract setGlobalProperties(properties: EventProperties): void;

  abstract forceStartSessionRecording(): void;

  startSessionRecording(): void {
    if (
      this.recordingSampleRate > 0 &&
      Math.random() <= this.recordingSampleRate
    ) {
      this.forceStartSessionRecording();
      this.recordingSampleRate = 0; // prevent this branch execution again
    }
  }
}
